import { Routes } from '@angular/router';
import { authGuard } from './core/auth-guard';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () => import('./pages/home/home').then((m) => m.Home),
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login').then((m) => m.Login),
  },
  {
    path: 'check-email',
    loadComponent: () => import('./pages/check-email/check-email').then((m) => m.CheckEmail),
  },
  {
    path: 'auth/callback',
    loadComponent: () =>
      import('./pages/auth-callback/auth-callback').then((m) => m.AuthCallback),
  },
  {
    path: 'pricing',
    loadComponent: () => import('./pages/pricing/pricing').then((m) => m.Pricing),
  },
  {
    path: 'share/:token',
    loadComponent: () => import('./pages/share-view/share-view').then((m) => m.ShareView),
  },
  {
    path: 'privacy',
    loadComponent: () => import('./pages/legal/privacy').then((m) => m.Privacy),
  },
  {
    path: 'terms',
    loadComponent: () => import('./pages/legal/terms').then((m) => m.Terms),
  },
  {
    path: 'billing',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/billing/billing').then((m) => m.Billing),
  },
  {
    path: 'billing/success',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/billing-success/billing-success').then((m) => m.BillingSuccess),
  },
  {
    path: 'billing/canceled',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/billing-canceled/billing-canceled').then((m) => m.BillingCanceled),
  },
  {
    path: 'app',
    canActivate: [authGuard],
    loadComponent: () => import('./shared/app-shell/app-shell').then((m) => m.AppShell),
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () => import('./pages/dashboard/dashboard').then((m) => m.Dashboard),
      },
      {
        path: 'moodboard',
        loadComponent: () => import('./pages/moodboard/moodboard').then((m) => m.Moodboard),
      },
      {
        path: 'collections',
        loadComponent: () => import('./pages/collections/collections').then((m) => m.Collections),
      },
      {
        path: 'moodboard/:id',
        loadComponent: () =>
          import('./pages/capture-detail/capture-detail').then((m) => m.CaptureDetail),
      },
      {
        path: 'events',
        loadComponent: () => import('./pages/events/events').then((m) => m.Events),
      },
      {
        path: 'events/:id',
        loadComponent: () =>
          import('./pages/event-detail/event-detail').then((m) => m.EventDetail),
      },
      {
        path: 'suppliers',
        loadComponent: () => import('./pages/suppliers/suppliers').then((m) => m.Suppliers),
      },
      {
        path: 'suppliers/:id',
        loadComponent: () =>
          import('./pages/supplier-detail/supplier-detail').then((m) => m.SupplierDetail),
      },
      {
        path: 'messages',
        loadComponent: () => import('./pages/messages/messages').then((m) => m.Messages),
      },
      {
        path: 'ai',
        loadComponent: () => import('./pages/denim-ai/denim-ai').then((m) => m.DenimAi),
      },
      {
        path: 'team',
        loadComponent: () => import('./pages/team/team').then((m) => m.Team),
      },
      {
        path: 'workspace',
        loadComponent: () => import('./pages/workspace/workspace').then((m) => m.WorkspacePage),
      },
      {
        path: 'notifications',
        loadComponent: () =>
          import('./pages/notifications/notifications').then((m) => m.Notifications),
      },
      {
        path: 'profile',
        loadComponent: () => import('./pages/profile/profile').then((m) => m.Profile),
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
